import { Box, Grid } from '@mui/material';
import { Button, DetailWrapperDiv, TextField, Typography } from 'app/shared';
import { ROUTES } from 'app/utils';
import { IUserSchema } from 'generated/axios';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';

interface Props {
  loggedUser: IUserSchema | undefined;
}

export const AdminProfile = ({ loggedUser }: Props) => {
  const navigate = useNavigate();

  return (
    <DetailWrapperDiv>
      <Typography detailTitle>{t('common.myProfile')}</Typography>
      <Grid container spacing={2}>
        <Grid size={6}>
          <TextField disabled label={t('user.lastName')} value={loggedUser?.last_name} />
        </Grid>
        <Grid size={6}>
          <TextField disabled label={t('user.firstName')} value={loggedUser?.first_name} />
        </Grid>
        <Grid size={6}>
          <TextField disabled label={t('user.email')} value={loggedUser?.email} />
        </Grid>
      </Grid>
      <Box padding={4}>
        <Button onClick={() => navigate(ROUTES.changePassword)}>{t('actions.changePassword')}</Button>
      </Box>
    </DetailWrapperDiv>
  );
};
